import React from "react";
import { CalendarCheck, ArrowRight } from "lucide-react";

export const AvailabilityBanner = () => {
  return (
    <section
      data-testid="availability-banner"
      className="relative bg-gold border-b-2 border-navy overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-5">
        <div className="flex items-center gap-3 shrink-0">
          <span className="h-10 w-10 flex items-center justify-center bg-navy text-gold border-2 border-navy">
            <CalendarCheck className="h-5 w-5" strokeWidth={2.5} />
          </span>
          <span className="font-display uppercase text-navy text-sm sm:text-base tracking-[0.12em]">
            Booking update:
          </span>
        </div>
        <p className="font-display uppercase text-navy text-base sm:text-lg leading-tight flex-1">
          We're <span className="underline decoration-navy decoration-2 underline-offset-2">booked up</span> during the week —
          <span className="ml-1">now taking weekend jobs.</span>
          <span className="ml-2 font-body text-xs sm:text-sm normal-case tracking-normal text-navy/80 font-semibold">
            Pick a Sat / Sun slot below.
          </span>
        </p>
        <a
          href="#quote"
          data-testid="availability-banner-cta"
          className="shrink-0 inline-flex items-center gap-2 bg-navy text-gold px-4 sm:px-5 py-2.5 font-display uppercase text-xs sm:text-sm tracking-wider border-2 border-navy hover:bg-navy-dark transition-colors"
        >
          Book a weekend
          <ArrowRight className="h-4 w-4" strokeWidth={3} />
        </a>
      </div>
    </section>
  );
};
